module.exports = __webpack_public_path__ + "/img/MELF-Labeled-MgRZ8B.svg";